<template>
    <div class="page">
        <div class="login_register_forgetPassword w1345">
            <div class="left"></div>
            <div class="right">
                <div class="tit">
                    <div><img src="@/assets/login/logo.png" alt=""></div>
                    <!-- <div class="msg">缩水网 成就您的彩票梦想</div> -->
                </div>
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.w1345{
    width: 1345px;
}
.page {
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: skyblue;
}
.login_register_forgetPassword {
    background-image: url("@/assets/login/loginbg.png");
    height: 700px;
    background-size: cover;
    display: flex;
    > div {
        // border: 1px solid red;
        &.left {
            flex: 6;
        }
        &.right {
            width: 470px;
            background-color: #f0f3f7;
            // padding: 150px 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            .tit {
                text-align: center;
                margin-bottom: 50px;
            }
        }
    }
}
</style>